import DashboardIcon from "@mui/icons-material/Dashboard";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import StorefrontIcon from "@mui/icons-material/Storefront";
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  useMediaQuery,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  handleAllCompany,
  handleLogOut,
  handleModalAction,
} from "../redux/actoin";
import { API } from "../scripts/api";
import axiosInstance from "../scripts/axiosInspector";
import HeaderReq from "../scripts/functions/headerReq";
import SideBar from "./sidebar";
const Layout = ({ children }) => {
  const isMd = useMediaQuery("(min-width:1300px)");
  const dispatch = useDispatch();
  const [touchStartX, setTouchStartX] = useState(0);
  const [value, setValue] = React.useState(0);
  const { themeDisplay } = useSelector((state) => state.ThemeToggler);
  const location = useLocation();
  const navigate = useNavigate();
  const handleTouchStart = (event) => {
    setTouchStartX(event.touches[0].clientX);
  };
  const CurrentCompany = useSelector((state) => state.CurrentCompany);
  const { company } = CurrentCompany;
  const handleTouchMove = (event) => {
    const currentX = event.touches[0].clientX;
    const deltaX = currentX - touchStartX;

    const threshold = 50;
    if (deltaX > threshold) {
      dispatch(handleModalAction({ login: false }));
    } else if (deltaX < -threshold) {
      dispatch(handleModalAction({ login: true }));
    }
  };
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  useEffect(() => {
    axiosInstance
      .get(API.user.checkToken, HeaderReq(userInfo?.token))
      .then((res) => {})
      .catch((error) => {
        dispatch(handleLogOut());
      });
    setValue(
      location.pathname === "/"
        ? 0
        : location.pathname.split("/")[1] === "sell"
        ? 1
        : location.pathname.split("/")[1] === "buy"
        ? 2
        : location.pathname.split("/")[1] === "price"
        ? 3
        : 0
    );
  }, [location]);
  useEffect(() => {
    if (userInfo) {
      dispatch(handleAllCompany(userInfo, company));
    }
  }, [userInfo]);
  return (
    <>
      <main
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        className="flex min-h-[100vh] relative md:pb-0 pb-10"
      >
        {themeDisplay === "blue" ? (
          <img
            className="lg:max-h-[60vh] lg:w-[100vw] lg:object-cover  absolute left-0 top-[-340px]"
            src="/assets/images/login/2-01.svg"
            alt=""
          />
        ) : themeDisplay === "green" ? (
          <img
            className="lg:max-h-[60vh] lg:w-[100vw] lg:object-cover  absolute left-0 top-[-340px]"
            src="/assets/images/login/3-01.svg"
            alt=""
          />
        ) : themeDisplay === "orange" ? (
          <img
            className="lg:max-h-[60vh] lg:w-[100vw] lg:object-cover  absolute left-0 top-[-340px]"
            src="/assets/images/login/4-01.svg"
            alt=""
          />
        ) : themeDisplay === "dark" ? (
          <img
            className="lg:max-h-[60vh] lg:w-[100vw] lg:object-cover  absolute left-0 top-[-340px]"
            src="/assets/images/login/5-01.svg"
            alt=""
          />
        ) : (
          <img
            className="lg:max-h-[60vh] lg:w-[100vw] lg:object-cover  absolute left-0 top-[-340px]"
            src="/assets/images/login/1-01.svg"
            alt=""
          />
        )}

        {isMd ? (
          <SideBar />
        ) : (
          <>
            {/*    <Drawer
              anchor="right"
              open={modals?.login}
              onClose={() => dispatch(handleModalAction({ login: false }))}
            >
              <SideBar />
            </Drawer> */}
          </>
        )}

        <Box
          component={"section"}
          sx={{
            pl: isMd ? "16.75rem" : "",
            bgcolor: (theme) =>
              theme.palette.mode === "dark" ? "#170258" : "#fefcfc",
          }}
          className="w-full pb-7"
        >
          {children}
        </Box>
        {!isMd && (
          <Paper
            sx={{
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              py: "5px",
              zIndex: 3333,
            }}
            elevation={3}
            className={`overflow-hidden ${
              themeDisplay === "dark" ? "darkMode" : ""
            } bottomNavigation`}
          >
            {themeDisplay === "blue" ? (
              <img
                className="  absolute left-0 bottom-[0px] z-0"
                src="/assets/images/login/2-02.svg"
                alt=""
              />
            ) : themeDisplay === "green" ? (
              <img
                className="  absolute left-0 bottom-[0px] z-0"
                src="/assets/images/login/3-02.svg"
                alt=""
              />
            ) : themeDisplay === "orange" ? (
              <img
                className="  absolute left-0 bottom-[0px] z-0"
                src="/assets/images/login/4-02.svg"
                alt=""
              />
            ) : themeDisplay === "dark" ? (
              <img
                className="  absolute left-0 bottom-[0px] z-0"
                src="/assets/images/login/5-02.svg"
                alt=""
              />
            ) : (
              <img
                className="  absolute left-0 bottom-[0px] z-0"
                src="/assets/images/login/1-02.svg"
                alt=""
              />
            )}

            <BottomNavigation
              showLabels
              value={value}
              onChange={(event, newValue) => {
                setValue(newValue);
              }}
              className="bottomNavigation"
            >
              <BottomNavigationAction
                label="داشبورد"
                icon={<DashboardIcon />}
                onClick={() => navigate("/")}
              />
              <BottomNavigationAction
                label="فروش"
                icon={<StorefrontIcon />}
                onClick={() => navigate("/sell")}
              />
              <BottomNavigationAction
                label="خرید"
                icon={<ShoppingCartIcon />}
                onClick={() => navigate("/buy")}
              />
              {/*      <BottomNavigationAction
                label="هزینه"
                icon={<AttachMoneyIcon />}
                onClick={() => navigate("/price")}
              /> */}
            </BottomNavigation>
          </Paper>
        )}
      </main>
    </>
  );
};

export default Layout;
